<template>
  <Bar
    v-if="chartData.labels.length > 0"
    :chart-options="chartOptions"
    :chart-data="chartData"
    :chart-id="chartId"
    :dataset-id-key="datasetIdKey"
    :plugins="plugins"
    :css-classes="cssClasses"
    :styles="styles"
  />
</template>
<script>

import { Bar } from 'vue-chartjs'

export default {
  components: {
    Bar
  },
  props: {
    list: {
      type: Array,
      default: () => { return [] }
    },
    chartId: {
      type: String,
      default: 'bar-chart'
    },
    datasetIdKey: {
      type: String,
      default: 'label'
    },
    width: {
      type: Number,
      default: 100
    },
    height: {
      type: Number,
      default: 100
    },
    cssClasses: {
      default: '',
      type: String
    },
    styles: {
      type: Object,
      default: () => {
        return {
          height: '200px'
        }
      }
    },
    plugins: {
      type: Array,
      default: () => { return [] }
    }
  },
  data () {
    return {
      chartOptions: {
        responsive: true,
        maintainAspectRatio: false,
        scaleFontColor: '#FFFFFF',
        plugins: {
          legend: {
            display: false
          }
        } //,
        // scales: {
        //   x: {
        //     ticks: {
        //       color: '#EEE'
        //     }
        //   },
        //   y: {
        //     ticks: {
        //       color: '#EEE'
        //     }
        //   }
        // }
      }
    }
  },
  computed: {
    chartData: {
      get () {
        const dataset = {
          data: [],
          backgroundColor: 'rgb(55, 205, 190)'
        }
        const labels = []
        for (const item of this.list) {
          labels.push(item.name)
          dataset.data.push(item.total)
        }
        return {
          labels,
          datasets: [dataset]
        }
      }
    }
  }
}
</script>
